// extracted by mini-css-extract-plugin
export default {"logo":"templates-application-loading-module__logo","opacity":"templates-application-loading-module__opacity"};